import { useMutation, useQueryClient } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosPatch, axiosGet } from 'utils/apis/axios';

const updateArtworkInventory = async ({ artworkId, payload }) => {
  const { data } = await axiosPatch(false, API.ARTWORK.UPDATE_ARTWORK_IN_STOCK(artworkId), payload);
  return data;
};

export const listArtworkInStockKey = (params) => [API.ARTWORK.ARTWORK_NEW_ARRIVAL, params];

export const fetchListArtworkInStock = async ({ tab, user_uuid }) => {
  const url = `${API.ARTWORK.ARTWORK_NEW_ARRIVAL}?tab=${tab}&user_uuid=${user_uuid}`;
  const { data } = await axiosGet(false, url);
  return data;
};

const useUpdateInventory = (defaultParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ artworkId, payload }) => updateArtworkInventory({ artworkId, payload }),
    onSuccess: (_data, variables = {}) => {
      const tab = variables.tab ?? defaultParams.tab;
      const user_uuid = variables.user_uuid ?? defaultParams.user_uuid;

      if (tab !== undefined && user_uuid) {
        const params = { tab: String(tab), user_uuid: String(user_uuid) };
        const key = listArtworkInStockKey(params);
        queryClient.invalidateQueries({ queryKey: key });
        queryClient.prefetchQuery({
          queryKey: key,
          queryFn: () => fetchListArtworkInStock(params),
        });
      }

      queryClient.invalidateQueries({ queryKey: [API.ARTWORK.ARTWORK_NEW_ARRIVAL] });
      queryClient.refetchQueries({ queryKey: [API.ARTWORK.ARTWORK_NEW_ARRIVAL] });
    },
  });
};

export default useUpdateInventory;
